import { TValidationResult } from '@settings/data-access';

export enum SystemModules {
  Totalpass = '7d306ae7-3a62-4d2e-bbb7-ec973f029a84',
  Gympass = '78567d75-39c1-43df-9ece-cc32ff554de2',
  Facial = '033ac824-6786-4071-9180-e9c10d742ef1',
  TreiNo = '38299a3b-5e4c-447a-ba9a-ab9e7f19b4d2',
  CRM = '6e2a0f78-a58f-47be-8f91-85babcbe5b9f',
  Actuar = '45c45478-0efc-4def-8ff9-7636e3e72c18',
  Administrativo = 'cf7ff341-2052-458c-97f4-3ca8cf83b91d',
  Whatsapp = 'd8fda503-805e-4746-8003-f2c050b03321',
  Helpdesk = 'aecd8154-509a-4eec-9533-0ef14b975e35',
  Apuracao = '6cb379c9-65f4-4e68-86f9-ac3956c9f257',
  AvaliacaoFisica = '3085ce66-a968-49ee-a88e-b5b9c7e2e59a',
  Gestor = '475658a0-236b-4772-b77b-e771ecca66d2',
  Contratos = '6be95655-afba-492d-90d4-4637397b3b84',
  ActuarWeb = 'f45c6900-64d6-4e04-a273-46a410501532',
  Cobranca = 'b733f377-b7b1-4701-b654-62ee6d835137',
  NotaFiscal = '2322c49a-0ba8-4056-9854-3892edfe3f16',
  Acesso = '24a44ab0-4d95-4e98-9eb5-587553c5d7e4',
}

export type TPersonModule = {
  ProductId: string;
  Name: string;
  Icon: string;
  CategoryType: number;
  IsActive: boolean;
  Operation: unknown | null;
  ValidationResult: TValidationResult;
  IsValid: boolean;
};

